import { render, staticRenderFns } from "./VoterMaintenance.vue?vue&type=template&id=4ab48b37"
import script from "./VoterMaintenance.vue?vue&type=script&lang=js"
export * from "./VoterMaintenance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports